/**
 * 广告业务专用（暂不通用）
 */

const isH5 = false // TODO: 这里先写死，后面通过navigator.userAgent区分（需要 app支持）

/**
 * 关闭 webview
 */
export function closeWebView() {
  if (isH5) {
    window.history.back()
  } else {
    window.location.href = 'protocol://action/finish'
  }
}

let urlPrefix = `protocol://action/goin/${location.origin}/patient`
if (location.hostname === 'localhost' || isH5) {
  urlPrefix = ''
}

export function goPageProfitList() {
  window.location.href = `${urlPrefix}/ad-profit-list`
}

export function goPageCouponInfo() {
  window.location.href = `${urlPrefix}/ad-coupon-info`
}
